import React, { memo } from "react";
import { NavLink, useLocation } from "react-router-dom";

import Link from "../link.svg?react";
import { NavItemType } from "../Navbar";
interface ElementNavBarProps {
  navItem: NavItemType;
  onLinkClick?: () => void;
  open?: boolean;
  showLinkLogo?: boolean;
  toggleNavbar?: () => void;
  isTopNavbar?: boolean;
}

const ElementNavBar: React.FC<ElementNavBarProps> = ({
  navItem,
  onLinkClick,
  open = true,
  showLinkLogo = true,
  toggleNavbar,
  isTopNavbar = false,
}) => {
  const location = useLocation();
  const isAnchor = navItem.href?.startsWith("#");

  const match = () => {
    if (isAnchor) return false;
    if (navItem.href?.split("/")[1] === location.pathname.split("/")[1]) {
      return true;
    }
    return false;
  };

  const handleLinkClick = () => {
    if (navItem.link && toggleNavbar) {
      toggleNavbar();
    }
    if (onLinkClick) {
      onLinkClick();
    }
  };

  const hilightClass = navItem.hilight ? "hilight" : "";

  if (isAnchor) {
    return (
      <li
        className={`nav-item ${navItem.className ?? ""} ${hilightClass}`}
      >
        <a
          href={navItem.href}
          className="nav-link"
          onClick={handleLinkClick}
        >
          {navItem.icon && navItem.icon}
          {open && <span className="link-text">{navItem.text}</span>}
        </a>
      </li>
    );
  }

  return (
    <li
      className={`nav-item ${navItem.className ?? ""} ${match() ? "active" : ""} ${hilightClass}`}
    >
      <NavLink
        to={navItem.href ?? navItem.link ?? "/"}
        className={`nav-link `}
        onClick={handleLinkClick}
        aria-current="page"
        end={navItem.href === "/"}
        target={navItem.link ? "_blank" : "_self"}
      >
        {navItem.icon && navItem.icon}
        {open && (
          <span className="link-text">
            {navItem.text}
            {navItem.link && showLinkLogo && <Link />}
          </span>
        )}
      </NavLink>
    </li>
  );
};

export default memo(ElementNavBar);
